import OrderPage from './OrderPage';
export { OrderPage };
export default OrderPage;
